<template>
  <div class="navbar-custom" id="top-bar">
    <div class="topbar container-fluid">
      <div id="logo-1-display">
        <v-img :src="LogoPath"></v-img>
      </div>

      <ul class="topbar-menu d-flex align-items-center gap-3" id="log-out-btn">
        <span>
          <img
            :src="UserImage"
            alt="user-image"
            width="32"
            class="rounded-circle"
          />
          <v-btn plain @click="LogoutUser" class="white--text">
            <v-icon>mdi-exit-to-app</v-icon>
            Logout
          </v-btn>
        </span>
      </ul>
    </div>
  </div>
</template>
<script>
import Common from "@/Common.vue";
import companyConfig from "@/company_config.json";

export default {
  mixins: [Common],
  components: {},
  data() {
    return {
      drawer: false,
      group: null,
      LogoPath: "",
      UserImage: "",
    };
  },
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");
      var server_url = companyConfig.apiURL;
      this.LogoPath = server_url + "assets/images/logo.png";
      var user = this.$session.get("user");
      user = user == (null || undefined) ? {} : user;
      console.log({ user });
      this.UserImage = user.MemberImage;
      console.log("User Image" + this.UserImage);
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
    
<style lang="scss" scoped>
.mobile-menu {
  .sidebar-menu {
    background-color: #1a2942;
    padding-bottom: 1000px;
  }
}
</style>